import axios from 'axios';

let autenticado = true;

export function isAutenticado() {
    return autenticado;
}

export function setAutenticado(aut) {
    autenticado = aut;
}
const api = axios.create({
    baseURL: 'https://acesso.pickngo.online',
});

api.interceptors.response.use(
    function (response) {
        if (!response.data.sucesso) {
            if (response.data.autenticado === false && autenticado) {
                autenticado = false;
            }
        }
        return response;
    },
    function (error) {
        return Promise.reject(error);
    },
);

export { api };